<ion-row class="ion-align-items-center flex-no-wrap">
  <img [src]="exerciseImg" *ngIf="exerciseImg" class="ion-margin-end">
  <div class="fake-image" *ngIf="!exerciseImg"></div>
  <div class="text">{{ exerciseValue?.name }}</div>
  <ion-button fill="clear" class="ion-no-margin" (click)="openExercise($event)" *ngIf="exerciseValue">
    <ion-icon name="open"></ion-icon>
  </ion-button>
</ion-row>
